import { createSlice } from "@reduxjs/toolkit";

const paginations = createSlice({
  name: "paginations",
  initialState: {
    paginations: {},
  } as any,
  reducers: {
    setPaginationData(state, { payload }) {
      state.paginations = payload;
    },
  },
});

export const { setPaginationData } = paginations.actions;

export default paginations.reducer;
